export const DigitalVideoMeasurementViewability = ({
    MRC: {
        label: "MRC",
        id: 1
    },
    GroupM: {
        label: "GroupM",
        id: 2
    }
    //Not supported in planner as of now as per [CSYS-5218]
    // AVOC: {
    //     label: "AVOC",
    //     id: 3
    // },
    // CustomNoSound: {
    //     label: "100% In-View, 50% Duration",
    //     id: 4
    // }
});